import { render, staticRenderFns } from "./dynamicDetail.vue?vue&type=template&id=baf487aa"
import script from "./dynamicDetail.vue?vue&type=script&lang=js"
export * from "./dynamicDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports